import { IReportTableDefinition } from "@pages/reports/Report.utils";
import { ReportId } from "@pages/reports/ReportIds";

import { IAppContext } from "../../contexts/appContext/AppContext.types";

const ReportDefs: Partial<Record<ReportId, (context?: IAppContext) => IReportTableDefinition>> = {};

export const setReportDef = (reportId: ReportId, getDefinition: (context?: IAppContext) => IReportTableDefinition): void => {
    if (ReportDefs[reportId]) {
        throw new Error(`Report definition for ${reportId} already set`);
    }

    ReportDefs[reportId] = getDefinition;
};

// keep in standalone module to prevent circular dependency
export const getReportDef = (reportId: ReportId): () => IReportTableDefinition => {
    return ReportDefs[reportId];
};

export const getAllReportDefs = (): ((context?: IAppContext) => IReportTableDefinition)[] => {
    return Object.values(ReportDefs);
};